import React, { useEffect } from "react";
import {
  Container,
  Typography,
  Box,
  List,
  ListItem,
  ListItemText,
  Divider,
  Paper,
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

function AuthError() {
  useEffect(() => {
  const detectDevTools = () => {
    const threshold = 160;
    const start = performance.now();

    // debugger;

    const duration = performance.now() - start;

    if (duration > threshold) {
      // DevTools is open
      alert("DevTools is open. Closing assessment for security reasons.");
      window.location.href = '/auth-error'; // or trigger a logout or block
    }
  };

  const interval = setInterval(detectDevTools, 1000);

  return () => clearInterval(interval);
}, []);

  useEffect(() => {
    // Clear all stored data
    localStorage.clear();
    sessionStorage.clear();

    // Disable right-click
    const handleContextMenu = (e) => e.preventDefault();
    document.addEventListener("contextmenu", handleContextMenu);

    // Disable keyboard shortcuts (Ctrl, F12, etc.)
    const handleKeyDown = (e) => {
      const blockedKeys = [
        "F12",
        "Control",
        "Meta", // Cmd key on Mac
        "Alt",
      ];

      if (
        blockedKeys.includes(e.key) ||
        (e.ctrlKey && ["c", "v", "u", "s", "p"].includes(e.key.toLowerCase()))
      ) {
        e.preventDefault();
        return false;
      }
    };
    window.addEventListener("keydown", handleKeyDown);

    // Disable back navigation
    window.history.pushState(null, "", window.location.href);
    const preventBack = () => {
      window.history.pushState(null, "", window.location.href);
    };
    window.addEventListener("popstate", preventBack);

    // Cleanup
    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("popstate", preventBack);
    };
  }, []);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: '#f5f5f5',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Container maxWidth="md">
        <Paper elevation={3} sx={{ padding: 4 }}>
          <Box display="flex" justifyContent="center" mb={3}>
            <WarningAmberIcon color="error" sx={{ fontSize: 60 }} />
          </Box>

          <Typography variant="h6" color="error" fontWeight="bold" textAlign="center">
            Note: <Typography component="span" fontWeight={600} color="textPrimary">System records every single interruption during the Assessment.</Typography>
          </Typography>

          <Box mt={3} >
            <Typography variant="body1" gutterBottom fontWeight={600} >
              Interruption is recorded in the system due to one of the following possible reasons:
            </Typography>

            <List>
              <ListItem disablePadding>
                <ListItemText primary="1) You were trying to minimize OR toggle Assessment Console." />
              </ListItem>
              <ListItem disablePadding>
                <ListItemText primary="2) You have pressed special keys from your keyboard which are not allowed during Assessment." />
              </ListItem>
              <ListItem disablePadding>
                <ListItemText primary="3) You have tried to move out of Assessment Console which is not allowed." />
              </ListItem>
              <ListItem disablePadding>
                <ListItemText primary="4) You have tried to refresh the page." />
              </ListItem>
            </List>

            <Typography variant="body1" mt={2}>
              This window will close down and you have to <strong>re-launch the Assessment</strong> only after it is unlocked. Please be advised not to move out of console during the assessment and <strong>not to navigate</strong> to other applications during the assessment.
            </Typography>
          </Box>

          <Divider sx={{ my: 4 }} />

          <Box textAlign="center">
            <Typography variant="h6" gutterBottom>
              How to proceed
            </Typography>
            <Typography variant="body1">
              This window will close down now.
              <br />
              Please ensure that you <strong>do not move out</strong> of Assessment window during the assessment. Use only mouse to navigate.
            </Typography>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
}

export default AuthError;